import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { FulfilmentPdfPreviewDto } from "./FulfilmentPdfPreviewDto";

interface GetFulfilmentPdfPreviewRequest {
    taxPayerWorkspaceId: string;
    sourceDocumentId: string;
}

export function useGetFulfilmentPdfPreview() {
    const { t } = useTranslation();
    const headers = useHttpTaxManagerAppHeaders();

    const mutation = useMutation<
        FulfilmentPdfPreviewDto,
        Error,
        GetFulfilmentPdfPreviewRequest
    >({
        mutationFn: async (request) => {
            // TODO: source param is hardcoded since now we only support events coming from F24SaaS, but this should come from
            // the fulfilment entities. It should be refactored when working on https://teamsystem.atlassian.net/browse/DCT-2093.
            const response = await fetch(
                `${BASE_API_URL}/tenants/${request.taxPayerWorkspaceId}/fulfilments/${request.sourceDocumentId}/pdf-preview?source=F24SaaS`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return {
                content: new Uint8Array(await response.arrayBuffer()),
                type: response.headers.get("content-type") ?? "",
            };
        },
        meta: {
            errorMessage: t("errors.messages.getFulfilmentPdfPreview"),
        },
    });

    return mutation;
}
